import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_78: FaireProductEntity = {
  token: "catalog_prod_prod-78",
  type: "product",
  name: "Tabletop Accessory",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 40.28,
  msrpDollars: 100.7,
  sku: "AN0078",
  caseSize: 3,
  material: "Metal",
  collectionToken: "col_andean-touch",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 47,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["catalog_cat_womens-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
